import axios from 'axios';
import { countMarket, isEmpty, showMessage, toastr } from '../cores';
import { api_url } from '../cores/keys';
import { socket } from '../cores/socket';
import store from '../store';
import { ClearBetStore } from './betAction';
import { SetPageInfo, SetPageLoading } from './pageAction';
import {
   GET_EVENT_COUNT,
   GET_SPORTS_LIST,
   SET_ACTIVE_ID,
   SET_FILTER_ID,
   SET_FILTER_SORT,
   SET_PAGE_DATA,
   SET_SCORE_DATA,
   SET_EVENT_COUNT,
   SET_STORE_EVENT,
   SET_LOCATION,
   SET_LEAGUE,
   SET_SEARCHVALUE,
   SET_SEARCHTYPE,
   SET_URL,
   SET_LEVELBETTINGDATA,
   SET_SPORTID,
   SET_BET_SETTING,
   MARKET_SETTING,
   BASELINE_SETTING,
   SET_PROVIDERID,
   SET_RESULT_INFO,
   SET_GAME_RESULT_LIST,
   SET_SPORTS_SETTING,
   GET_BETGAME_TYPE,
   SET_MARKETSETTING,
   SET_SPORTSMARKETINFO,
   SET_LEAGUE_COUNT,
   SET_CLIKED
} from './types';
import { logoutUser } from './userActions';
import { sportPerPage } from '../../utils';

export const ClearSportsList = () => dispatch => {
   return dispatch({
      type: GET_SPORTS_LIST,
      payload: []
   })
}

export const SetSportsList = data => dispatch => {
   return dispatch({
      type: GET_SPORTS_LIST,
      payload: data
   })
}

// export const SetSportsFlag = data => dispatch => {
//    dispatch({
//       type: "getsportsflag",
//       payload: data
//    })
// }

export const GetEventCount = data => dispatch => {
   return dispatch({
      type: GET_EVENT_COUNT,
      payload: data
   })
}

export const GetDashboardSportsList = (data, clear = false, noActive = false, loading = true) => dispatch => {
   if (clear === true) {
      dispatch(ClearSportsList());
      dispatch(SetActiveId(''));
   } 
   if(loading)
      dispatch(SetPageLoading(true));

   const url = api_url + '/api/' + (data.pageType === 'toto' ? 'Sports' : 'Betgame') + '/getDashGameList';
   axios.post(url, { ...data })
      .then(res => {
         dispatch(SetPageLoading(false));
         if (res.data.status)
            // return showMessage(res.data.message);
            return "";
         if (!isEmpty(res.data.type)) {
            dispatch(SetBetgameType(res.data.type))
         }
         // 필요한 게임목록 요청
         const events = res.data.events;
         
         let gameList = [];
         events.forEach((item, index) => {
            return gameList.push(item.FixtureId)
         });
         const game_listData = { MessageType: 'GameList', data: gameList }
         if (window.ws.readyState === 1){
            window.ws.send(JSON.stringify(game_listData));
         }

         switch (res.data.type) {
            case 0:
               window.apiType = "lsports"
               break;
            case 1:
               window.apiType = "odds"
               break;
            case 2 :
               window.apiType = "betradar"
            default:
               break;
         }

         dispatch({
            type: SET_PAGE_DATA,
            payload: res.data
         })
         dispatch(SetSportsList(res.data.events));
      })
      .catch(err => {
       console.error('err: ', err);
         dispatch(SetPageLoading(false));
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
         else
            toastr.warning('잠시후 다시 시도해주세요.');
      })
}

export const getBigLeague = data => dispatch => {
   return dispatch({
      type: SET_LEAGUE_COUNT,
      payload:data
   })
}

export const GetSportsList = (data, clear = false, noActive = false, loading = true) => dispatch => {
   if (clear === true) {
      dispatch(ClearSportsList());
      dispatch(SetActiveId(''));
   } 
   if(loading)
      dispatch(SetPageLoading(true));

   const url = api_url + '/api/' + (data.pageType === 'toto' ? 'Sports' : 'Betgame') + '/getGameList';
   axios.post(url, { ...data })
      .then(res => {
         dispatch(SetPageLoading(false));
         if (res.data.status)
            return showMessage(res.data.message);
         if (!isEmpty(res.data.type)) {
            dispatch(SetBetgameType(res.data.type))
         }
         // 필요한 게임목록 요청
         const events = res.data.events;
         if(isEmpty(events)) {
            dispatch(SetUrl(""));
            dispatch({
               type: SET_PAGE_DATA,
               payload: res.data
            })
            dispatch(setSportsMarketInfo({}));
            return dispatch(SetSportsList(res.data.events));
         }
         
         let gameList = [];
         events.forEach((item, index) => {
            return gameList.push(item.FixtureId)
         });
         const game_listData = { MessageType: 'GameList', data: gameList }
         if (window.ws.readyState === 1){
            window.ws.send(JSON.stringify(game_listData));
         }

         switch (res.data.type) {
            case 0:
               window.apiType = "lsports"
               break;
            case 1:
               window.apiType = "odds"
               break;
            case 2 :
               window.apiType = "betradar"
            default:
               break;
         }

         dispatch({
            type: SET_PAGE_DATA,
            payload: res.data
         })
         dispatch(SetSportsList(res.data.events));
         if(data.pageType !== 'toto'){
            dispatch(SetUrl(res.data.gameUrl));
         }
         
         dispatch(SetPageInfo(data));

         if(!noActive){
            dispatch({
               type: SET_ACTIVE_ID,
               payload: isEmpty(events) ? '' : events[0].key
            })
            if(data.pageType === 'toto' && !isEmpty(events[0])){
               dispatch(GetIframeUrl(events[0].FixtureId));
               let resData = {
                  sportType: data.sportType,
                  gameType: data.gameType,
                  fixtureId: events[0].FixtureId
               }
               dispatch(GetMarketInfo(resData))
            }
         }

      })
      .catch(err => {
      console.error('err: ', err);
         dispatch(SetPageLoading(false));
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
         else
            toastr.warning('잠시후 다시 시도해주세요.');
      })

}

export const AddSportsList = (data, clear = false, noActive = true, loading = true) => dispatch => {
   if (clear === true) {
      dispatch(SetActiveId(''));
   } 
   if(loading){
      dispatch(SetPageLoading(true));
   }

   const url = api_url + '/api/' + (data.pageType === 'toto' ? 'Sports' : 'Betgame') + '/getGameList';
   axios.post(url, { ...data })
      .then(res => {
         let sportsList = store.getState().sports.data;
         dispatch(SetPageLoading(false));
         if (res.data.status)
            return showMessage(res.data.message);

         if(data.page > res.data.totalPage){
            return ;
         }

         if ((clear === true) && (isEmpty(res.data.events))){
            dispatch(setSportsMarketInfo({}));
            return dispatch(ClearSportsList());
         }
         if(isEmpty(res.data.events)) {
            dispatch(SetUrl(""));
            dispatch({
               type: SET_PAGE_DATA,
               payload: res.data
            })
            return dispatch(SetSportsList(sportsList));
         }
         else if(!clear){
            for(let i = 0; i < res.data.events.length; i++){
               const index = sportsList.findIndex(list => list.FixtureId === res.data.events[i].FixtureId);
               if(index > -1){
                  sportsList[index] = res.data.events[i];
                  res.data.events.splice(i, 1);
                  i--;
               }
            }
         }

         // const events = clear ? res.data.events : sportsList.concat(res.data.events);
         const events = res.data.events;
         
         let gameList = [];
         events.forEach((item, index) => {
            return gameList.push(item.FixtureId)
         });
         const game_listData = { MessageType: 'GameList', data: gameList }
         if (window.ws.readyState === 1){
            window.ws.send(JSON.stringify(game_listData));
         }

         switch (res.data.type) {
            case 0:
               window.apiType = "lsports"
               break;
            case 1:
               window.apiType = "odds"
               break;
            case 2 :
               window.apiType = "betradar"
         
            default:
               break;
         }
         res.data = {
            ...res.data,
            direction: data.direction,
         }
         dispatch({
            type: SET_PAGE_DATA,
            payload: res.data
         })

         if (data.pageType === 'toto') {
            events.sort((a, b) => {
               if (!isEmpty(a.Fixture) && !isEmpty(a.Fixture.StartDate) &&
                  !isEmpty(b.Fixture) && !isEmpty(b.Fixture.StartDate)) {

                     if((new Date(a.Fixture.StartDate)).getTime() > (new Date(b.Fixture.StartDate)).getTime()){
                        return 100;
                     }
                     else if((new Date(a.Fixture.StartDate)).getTime() === (new Date(b.Fixture.StartDate)).getTime()){
                        if(a.Fixture.League.Id.charCodeAt() > b.Fixture.League.Id.charCodeAt()){
                           return 50;
                        }
                        else if(a.Fixture.League.Id.charCodeAt() === b.Fixture.League.Id.charCodeAt()){
                           return 0;
                        }
                        else{
                           return -50;
                        }
                     }
                     else{
                        return -100;
                     }
               }
               else{
                  return 0
               }
            })
         }

         dispatch(SetSportsList(events));
         if(data.pageType !== 'toto'){
            dispatch(SetUrl(res.data.gameUrl));
         }
         
         dispatch(SetPageInfo(data));

         if(!noActive){
            dispatch({
               type: SET_ACTIVE_ID,
               payload: isEmpty(events) ? '' : events[0].key
            })
            if(data.pageType === 'toto' && !isEmpty(events[0])){
               dispatch(GetIframeUrl(events[0].FixtureId));
               let resData = {
                  sportType: data.sportType,
                  gameType: data.gameType,
                  fixtureId: events[0].FixtureId
               }
               dispatch(GetMarketInfo(resData))
            }
         }

      })
      .catch(err => {
      console.error('err: ', err);
         dispatch(SetPageLoading(false));
         //console.log('error:', err);
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
         else
            toastr.warning('잠시후 다시 시도해주세요.');
      })

}

export const GetMarketInfo = (data, loading = true) => dispatch => {
   dispatch(setSportsMarketInfo({}));
   if(loading) {
      dispatch(SetPageLoading(true));
   }
   const url = api_url + '/api/Sports/getGameInfo'
   axios.post(url, data)
   .then(res => {
      dispatch(SetPageLoading(false));
      if(res.data.success) {
         dispatch(setSportsMarketInfo(res.data.data))
      }
      else {
         toastr.warning(res.data.message)
      }

   })
   .catch(err => {
      console.error('err: ', err);
         dispatch(SetPageLoading(false));
         //console.log('error:', err);
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
         else
            toastr.warning('잠시후 다시 시도해주세요.');
      })

}

export const GetEvent = (data) => dispatch => {
   dispatch(SetEventStore([]));
   let allCount = store.getState().sports.eventCount
   const url = api_url + '/api/games/menu/sports/list';
   // //console.log(data)
   return new Promise( resolve =>{ 
      axios.post(url, { data })
      .then(res => {
         // //console.log("------------------------")
         // let store_events = [];
         let store_events = res.data.data;
         // Object.keys(res.data.data).sort().forEach((key) => {
         //    res.data.data[key].name = key;
         //    store_events.push(res.data.data[key]);
         // })
         //  //console.log(store_events)
         if (isEmpty(store_events)) return;
         Object.keys(allCount).forEach(key => {
            // //console.log(key, data.sportId, allCount[key], data)
            if (data.sportId == key) {
               allCount[key].data = store_events;
            }
         })
         // //console.log(allCount)   
         // dispatch(GetEventCount(allCount));
         dispatch(SetEventStore(store_events))
         resolve()
      })
      .catch(err => {
      console.error('err: ', err);
         //console.log('error:', err);
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
         else
            toastr.warning('잠시후 다시 시도해주세요.');
      })
   })
}

export const GetIframeUrl = (data) => dispatch => {
   const pageInfo = store.getState().page.pageInfo;
   let url = store.getState().sports.url;
   dispatch(SetUrl(url.split("token=")[0]));
   // if(pageInfo.sportType === "sport" && pageInfo.gameType === "prematch")
   if(pageInfo.gameType === "prematch"){
      return dispatch(SetUrl(""));
   }
      axios.post(api_url + "/api/Games/getFrontUrl", { fixtureId: data.toString() })
         .then(res => {
            if(res.data.status){
               return; // showMessage(res.data.message);
            }
            // //console.log(res.data)
            
            if(!isEmpty(res.data.frontUrl)){
               url = res.data.frontUrl
               if(!isEmpty(res.data.token)){
                  url = url + '?token=' + res.data.token + "&fixtureId=" + data.toString()
               }
               dispatch(SetUrl(url));
            }
         })
         .catch(err => {
      console.error('err: ', err);
            //console.log("err", err);
         })
      
}

export const ResultInfo = () => dispatch => {
  // //console.log(params);
    axios
      .post(api_url + "/api/Sports/getGameResultInfo", { })
      .then(res => {
        dispatch(setResultInfo(res.data))
      })
      .catch(err => {
      console.error('err: ', err);
        //console.log(err);
        if (store.getState().user.isAuthenticated)
          return dispatch(logoutUser());
        //console.log(err);
        // if (err.response && err.response.status === 401) {
        //     props.logoutUser();
        // } else {
        toastr.warning("잠시후 다시 시도해주세요.");
        // }
      })
};

export const getGameResultList = (params) => dispatch => {
   //console.log(params);
   dispatch(SetPageLoading(true));
   
     axios
       .post(api_url + "/api/Sports/getGameResultList", params )
       .then(res => {
          dispatch(SetPageLoading(false));
          if(res.data.status){
             return showMessage(res.data.message);
          }
          else{
             dispatch(setGameResultList(res.data.events));
             dispatch({ type: SET_PAGE_DATA, payload: res.data });
          }
       })
       .catch(err => {
          console.error('err: ', err);
          dispatch(SetPageLoading(false));
         //console.log(err);
         if (store.getState().user.isAuthenticated)
           return dispatch(logoutUser());
         //console.log(err);
         // if (err.response && err.response.status === 401) {
         //     props.logoutUser();
         // } else {
         toastr.warning("잠시후 다시 시도해주세요.");
         // }
       });
  }; 

export const SetEventStore = (data) => dispatch => {
   // //console.log(data)
   dispatch({
      type: SET_STORE_EVENT,
      payload: data
   })

}

export const SetActiveId = (data) => dispatch => {
   
   dispatch({
      type: SET_ACTIVE_ID,
      payload: data
   })

}

export const SetBetgameType = (data) => dispatch => {
   
   dispatch({
      type: GET_BETGAME_TYPE,
      payload: data
   })

}

export const SetScoreData = data => dispatch => {
   dispatch({
      type: SET_SCORE_DATA,
      payload: data
   })
}

export const SetFilterId = data => dispatch => {
   dispatch({
      type: SET_FILTER_ID,
      payload: data
   })
}

export const SetFilterSort = data => dispatch => {
   dispatch({
      type: SET_FILTER_SORT,
      payload: data
   })
}

export const SetEventCount = data => dispatch => {
   // console.log(data)
   dispatch({
      type: SET_EVENT_COUNT,
      payload: data
   })
}

export const SetLocation = data => dispatch => {
   // //console.log(data)
   dispatch({
      type: SET_LOCATION,
      payload: data
   })
}

export const SetLeague = data => dispatch => {
   dispatch({
      type: SET_LEAGUE,
      payload: data
   })
}

export const SetSearchValue = data => dispatch => {
   dispatch({
      type: SET_SEARCHVALUE,
      payload: data
   })
}

export const SetSearchType = data => dispatch => {
   dispatch({
      type: SET_SEARCHTYPE,
      payload: data
   })
}

export const SetSportId = data => dispatch => {
   dispatch({
      type: SET_SPORTID,
      payload: data
   })
}

export const SetUrl = data => dispatch => {
   dispatch({
      type: SET_URL,
      payload: data
   })
}

export const SetLevelBettingData = data => dispatch => {
   dispatch({
      type: SET_LEVELBETTINGDATA,
      payload: data
   })
}

export const SetBetSetting = data => dispatch => {
   dispatch({
      type: SET_BET_SETTING,
      payload: data
   })
}

export const SetClicked = data => dispatch => {
   dispatch({
      type: SET_CLIKED,
      payload: data
   })
}

export const SetMarketSetting = (data) => dispatch => {
   dispatch({
      type: MARKET_SETTING,
      payload: data
   })
}

export const SetMarket_Setting = (data) => dispatch => {
   dispatch({
      type: SET_MARKETSETTING,
      payload: data
   })
}

export const SetBaselineSetting = (data) => dispatch => {
   dispatch({
      type: BASELINE_SETTING,
      payload: data
   })
}

export const SetProviderId = (data) => dispatch => {
   dispatch({
      type: SET_PROVIDERID,
      payload: data
   })
}

export const setResultInfo = (data) => dispatch => {
   dispatch({
      type: SET_RESULT_INFO,
      payload: data
   })
}

export const setGameResultList = (data) => dispatch => {
   dispatch({
      type: SET_GAME_RESULT_LIST,
      payload: data
   })
}

export const setSportsSetting = (data) => dispatch => {
   dispatch({
      type: SET_SPORTS_SETTING,
      payload: data
   })
}

export const setSportsMarketInfo = (data) => dispatch => {
   dispatch({
      type: SET_SPORTSMARKETINFO,
      payload: data
   })
}


// WEBPACK FOOTER //
// ./src/common/actions/sportsAction.js